import styled from 'styled-components';

const OutlineTag = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 500;
  color: #595959;
  letter-spacing: 0.04em;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;

export default OutlineTag;
